module.exports = __webpack_public_path__ + "static/media/laundry-5.5ad50030.jpg";